import { guestOpacApi } from "@/lib/api/guest-opac";

const cache = new Map<string, Promise<unknown>>();
const prefetched = new Set<string>();

export function prefetchGuestResource(publicId: string, tenantSlug: string) {
  const key = `${tenantSlug}:${publicId}`;
  if (prefetched.has(key)) return;
  prefetched.add(key);
  if (!cache.has(key)) {
    cache.set(
      key,
      guestOpacApi.getResource(publicId, tenantSlug).catch(() => undefined)
    );
  }
}

export function canHoverPrefetch(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(hover: hover)").matches;
}
